const store = new Vuex.Store({
    state: {
        products: {},
        order: {
            items: [],
        },
        minScroll: 50,
        white: false,
        openedCallbackModal: false,
        openedOrderCallModal: false,
    },
    mutations: {
        SET_CALLBACK_MODAL(state, value) {
            state.openedCallbackModal = value
        },
        SET_ORDER_CALL_MODAL(state, value) {
            state.openedOrderCallModal = value
        },
        SET_WHITE(state, white) {
            state.white = white
        },
        SET_ORDER_ITEMS(state, items) {
            state.order.items = items;
        },
        UPDATE_ITEM_IN_CART(state, {product_id, count}) {
            if (count == 0) {
                state.order.items = state.order.items.filter(function (item) {
                    return item.product.id != product_id;
                });
                return;
            }
            for (let index in state.order.items) {
                let orderItem = state.order.items[index];
                if (orderItem.product.id == product_id) {
                    state.order.items[index].count = count;
                    return;
                }
            }
            state.order.items.push({
                product: state.products[product_id],
                count: count,
            });
        },
        SET_PRODUCTS(state, payload) {
            for (let item of payload) {
                state.products[item.id] = item;
            }
        },
        CLEAR_CART(state) {
            state.order.items = [];
        }
    },
    actions: {
        init({dispatch}){
            dispatch('loadProductFromServer');
        },
        setCallbackModal({commit}, value) {
            commit('SET_CALLBACK_MODAL', value)
        },
        setOrderCallModal({commit}, value) {
            commit('SET_ORDER_CALL_MODAL', value)
        },
        saveOrderInCookie({state}) {
            let data = {};
            for (let item of state.order.items) {
                data[item.product.id] = item.count;
            }
            CookieHelper.setCookie('order', JSON.stringify(data), (new Date(Date.now() + 86400 * 1000)).toUTCString(), '/');
        },
        setWhite({commit}, white) {
            commit('SET_WHITE', white)
        },
        clearCart({commit}) {
            commit("CLEAR_CART");
            CookieHelper.setCookie('order', JSON.stringify({}), (new Date(Date.now() + 86400 * 1000)).toUTCString(), '/');
        },
        updateItemInCart({state, commit, dispatch}, {updateDirection, product_id}) {
            let count = 0;
            if (updateDirection != 0) {
                for (let item of state.order.items) {
                    if (item.product.id == product_id) {
                        count = item.count;
                        break;
                    }
                }
            }
            switch (updateDirection) {
                case 1:
                    count++;
                    break;
                case 0:
                    count = 0;
                    break;
                case -1:
                    count--;
                    break;
            }
            if (count < 0) {
                count = 0;
            }
            commit("UPDATE_ITEM_IN_CART", {product_id, count});
            dispatch("saveOrderInCookie");
        },
        setItemInCart({commit, dispatch}, {count, product_id}) {
            if (count < 0) {
                count = 0;
            }
            commit("UPDATE_ITEM_IN_CART", {product_id, count});
            dispatch("saveOrderInCookie");
        },
        loadProductFromServer({commit, dispatch}) {
            axios.get('/api/get-products').then(function (response) {
                if (response.data.success) {
                    commit("SET_PRODUCTS", response.data.data);
                    dispatch('loadOrderFromCookie');
                }
            });
        },
        loadOrderFromCookie({state, commit}) {
            let cookie = CookieHelper.getCookie('order');
            if (cookie) {
                cookie = JSON.parse(cookie);
                let items = [];
                for (let product_id in cookie) {
                    items.push({
                        count: cookie[product_id],
                        product: state.products[product_id],
                    });
                }
                commit("SET_ORDER_ITEMS", items);
            }
        }
    },
    getters: {
        getDivider: state => product_id => {
            for (let index in state.products) {
                let item = state.products[index];
                if (item.id == product_id) {
                    return item.divider;
                }
            }
            return 1;
        },
        getProductQuantity: state => product_id => {
            for (let item of state.order.items) {
                if (item.product.id == product_id) {
                    return item.count;
                }
            }
            return 0;
        },
    }
});

function scrolling() {
    let mustBeWhite = false;
    if (window.pageYOffset >= store.state.minScroll) {
        mustBeWhite = true;
    }
    if (store.state.white != mustBeWhite) {
        store.dispatch('setWhite', mustBeWhite)
    }
}

scrolling();

if (window.location.pathname === '/') {
    window.addEventListener("scroll", scrolling);
} else {
    store.dispatch('setWhite', true)
}

store.dispatch('init');
